import React, { useState } from 'react'; 
import '@picocss/pico'
import VoterLogin from "./components/VoterLogin";
import Lobby from "./components/Lobby";
import PollForm from "./components/PollForm";

function Public() {
    const [ stage, setStage ] = useState(1)
    const [ voterEmail, setVoterEmail ] = useState("")
    const [ activePoll, setActivePoll ] = useState(null)

    const handleVoterEmailSubmit = voterEmail => {
        setVoterEmail(voterEmail)
        setStage(2)
    }

    const handleNewPoll = newPoll => {
        setActivePoll(newPoll)
        setStage(3)
    }

    const handleChoiceSubmit = choice => {
        fetch("/api/vote", {
            method: "POST",
            body: JSON.stringify({
                email: voterEmail,
                choice: choice,  
            })
        })
            .then(r => r.json())
            .then(r => { setStage(4) })
    }

    const renderCurrentView = () => {
        switch (stage) {
            case 1:
                return (
                    <VoterLogin
                        submitVoterEmail={handleVoterEmailSubmit}
                    />
                )
                break;
            case 2:
                return (
                    <Lobby 
                        voter={voterEmail}
                        newPoll={handleNewPoll}
                    />
                )
            case 3:
                return (
                    <PollForm 
                        activePoll={activePoll}
                        onChoiceSubmit={handleChoiceSubmit}
                    />
                )
            case 4:
                return (
                    <div>
                        <h1>Danke</h1>
                        <button onClick={() => { setStage(2) }}>Weiter</button>
                    </div>
                )
        }
    }

    return (
        <div className="container">
            { renderCurrentView() }
        </div>
    )
}

export default Public;
